import { render, staticRenderFns } from "./BlockInstructions.vue?vue&type=template&id=5499c8ef&"
import script from "./BlockInstructions.vue?vue&type=script&lang=js&"
export * from "./BlockInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports